import { render, staticRenderFns } from "./MomentCreate.vue?vue&type=template&id=10b08ffc&scoped=true&"
import script from "./MomentCreate.vue?vue&type=script&lang=js&"
export * from "./MomentCreate.vue?vue&type=script&lang=js&"
import style0 from "./MomentCreate.vue?vue&type=style&index=0&id=10b08ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b08ffc",
  null
  
)

export default component.exports